<template>
  <div class="card">
    <div class="card-body">
      <div class="row m-2">
        <div class="col-10 p-l-0 title">
          <img src="/theme/icons/readers-in-hole.svg" class="m-r-20">
          <span>ЗАРАЗ В ЧИТАЛЬНІЙ ЗАЛІ</span>
        </div>
        <div class="col-2 p-r-0 text-right">
          <div class="btn btn-in-hole">{{ booksInHole.total }}</div>
        </div>
      </div>
      <hr>
      <div class="p-t-10">
        <a v-for="(item,i) in booksInHole.data" style="width: 100%">
          <table>
            <tr>
              <td class="reader-avatar" @click="$root.searchReader(item.code)">
                <div class="dropify-wrapper" :class="item.debtor_days ? 'debtor' : ''">
                  <div class="dropify-preview" style="display: block; padding: 0px;">
                                        <span class="dropify-render" :style="'background: url(' + (item.photo ? '/uploads/'+ item.photo : '/images/avatar.png') +')'">
                                        </span>
                  </div>
                </div>
              </td>
              <td class="reader" :class="item.debtor_days ? 'debtor' : ''">
                <a @click="$root.searchReader(item.code)">{{ item.fullname }}</a>
                <br>
                <div class="m-l-15 m-t-10">
                  <a class="book" @click="$root.searchInLibrary(book.code)" v-for="book in item.books.filter(el=>el.status_id == 2)">{{ book.description.title }}<br></a>
                </div>
              </td>
            </tr>
          </table>
          <hr v-if="i != booksInHole.data.length - 1">
        </a>
      </div>
      <div class="m-t-20 text-center" @click="readersActive" v-if="booksInHole.current_page != booksInHole.last_page">
        <img src="/theme/icons/more-circle.svg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InHole",
  data(){
    return {
      booksInHole: {data:[]},
    }
  },
  mounted() {
    this.readersActive();
  },
  methods:{
    readersActive: function() {
      let url;
      if(this.booksInHole.data.length == 0){
        url = '/library/readers-active';
      } else{
        url = this.booksInHole.next_page_url;
      }
      if(url){
        axios.get(url)
            .then(response => {
              if(this.booksInHole.data.length > 0){
                let readers = this.booksInHole.data;
                this.booksInHole = response.data;
                this.booksInHole.data = readers.concat(response.data.data);
              }else{
                this.booksInHole = response.data;
              }
            });
      }
    },
  }
}
</script>

<style scoped>
    .btn-in-hole {
      margin-top: 5px;
      color: white;
      text-align: center;
      text-transform: uppercase;
      font-size: 12px;
      line-height: 10px;
      height: 24px;
      background-color: #A0E0BA;
    }

    .reader-avatar{
      background: unset;
    }
    .reader-avatar:hover{
      background: unset;
    }

    .reader-avatar .dropify-wrapper {
      background: unset;
      border: 3px solid #A7AFBA;
      border-radius: 50%;
      width: 64px;
      height: 64px;
    }
    .reader-avatar .dropify-wrapper .dropify-preview .dropify-render {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      overflow: hidden;
      background-size: cover !important;
      background-position: center !important;
    }

    .reader-avatar .dropify-wrapper.debtor{
      border: 3px solid #FE9780;
    }
    .reader:hover,
    .reader{
      padding-left: 15px;
      color: #414141;
      font-size: 18px;
      line-height: 1;
    }
    .reader.debtor:hover,
    .reader.debtor{
      color: #FE9780;
    }
    a{
      text-decoration: none;
      cursor: pointer;
    }
    .book{
      color:#A7AFBA;
      font-size: 12px;
      padding:0;
      cursor: pointer;
      display: list-item;
    }
    .book:hover{
      color:#212529;
    }
</style>